import React, { useState, useEffect } from 'react';
import { Modal, Icon } from '@b-design/fusion';
import Button from '@/components/Button';

import './index.less';
import $i18n from '../../i18n';

interface ConfirmProps {
  /**
   * 需要点击二次确认的控件或文本
   */
  trigger: string | React.ReactNode;
  /**
   * 对话框宽度
   */
  width?: number | string;
  /**
   * 二次确认对话框标题
   */
  dialogTitle?: string | React.ReactNode;
  /**
   * 二次确认对话框内容
   */
  dialogContent?: string;
  /**
   * 对话框Icon类型
   */
  colorIcon?: string;
  /**
   * 是否默认可见
   */
  show?: boolean;
  /**
   * 是否为文本类型组件
   */
  type?: string;
  /**
   * 关闭时回调
   */
  onClose?: () => void;
  /**
   * 点击确认时回调
   */
  onClick?: () => void;
  /**
   * 触发控件样式覆写
   */
  style?: React.CSSProperties;
  /**
   * 取消按钮文案
   */
  cancelText?: string;
  /**
   * 确认按钮文案
   */
  okText?: string;
}

const Confirm = (props: ConfirmProps) => {
  const {
    trigger,
    width = 400,
    dialogTitle,
    dialogContent,
    // colorIcon = 'warning',
    show = false,
    type,
    onClose = () => {},
    onClick = () => {},
    style = {},
    cancelText = $i18n.get({ id: 'aopf.components.Confirm.Cancel', dm: '取消' }),
    okText = $i18n.get({ id: 'aopf.components.Confirm.Ok', dm: '确定' }),
  } = props;

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
    }
  }, [show]);

  const handleClose = () => {
    setVisible(false);
    if (onClose) {
      onClose();
    }
  };

  const handleOk = async () => {
    try {
    await onClick();
    } finally {
      setVisible(false);
    }
  };

  return (
    <span>
      {typeof trigger === 'string' ? (
        <Button
          id="topLeft"
          onClick={() => setVisible(true)}
          text
          className={type === 'btnText' ? 'menu-dialog' : ''}
          style={{ color: 'var(--superapp-primary-1)', position: 'relative', height: 16, ...style }}
        >
          {trigger}
        </Button>
      ) : (
        <span onClick={() => setVisible(true)}>{trigger}</span>
      )}

      <Modal
        style={{ width: width, ...style }}
        visible={visible}
        onClose={handleClose}
        footer={[
          <div className="dialog-footer">
            <Button className="dialog-btn" type="normal" onClick={handleClose}>
              {cancelText}
            </Button>
            <Button type="primary" onClick={handleOk}>
              {okText}
            </Button>
          </div>,
        ]}
      >
        <div className="dialog-header">
          <span className="dialog-title">{dialogTitle}</span>
        </div>
        <div className="dialog-body">{dialogContent}</div>
      </Modal>
    </span>
  );
};

export default Confirm;
